/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Plausible_SrcInputs */

const en_admin_settings_fields_plausible_src = /** @type {(inputs: Admin_Settings_Fields_Plausible_SrcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script Src`)
};

/**
* | output |
* | --- |
* | "Script Src" |
*
* @param {Admin_Settings_Fields_Plausible_SrcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_plausible_src = /** @type {((inputs?: Admin_Settings_Fields_Plausible_SrcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Plausible_SrcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_plausible_src(inputs)
});
export { admin_settings_fields_plausible_src as "admin.settings.fields.plausible_src" }